import { LowerCasePipe, NgClass, NgIf } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { CodeAndName } from '@lx/shared/types';
import { Company, CompanyEnum } from '../../models/company.model';
import { NameAndPrice, Note } from '../../models/types';
import { CurrencyComponent } from '../currency/currency.component';
import { MoreInfoListComponent } from '../more-info/more-info-list/more-info-list.component';
import { NotesComponent } from '../notes/notes.component';
import { SubjectEnum } from '../../utils/notes.utils';
import { PriceListNote } from '../../models/priceslist-note.model';
import { NotesService } from '../../services/notes.service';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-junior-camps-private-lessons',
  imports: [MoreInfoListComponent, CurrencyComponent, NgClass, LowerCasePipe, NgIf, NotesComponent],
  templateUrl: './junior-camps-private-lessons.component.html',
  styleUrls: ['./junior-camps-private-lessons.component.scss'],
})
export class JuniorCampsPrivateLessonsComponent implements OnInit {
  @Input() privateLessons: NameAndPrice[] = [];
  @Input() currency: CodeAndName | undefined;
  @Input() company: Company = CompanyEnum.ALP;
  @Input() privateLessonsNotes: PriceListNote[] | undefined;

  notes: Note[] | undefined;
  notationMarks: Record<string, string> | undefined;

  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    const privateLessons = this.notesService.getNotes(this.privateLessonsNotes, SubjectEnum.PRIVATE_LESSONS);
    if (privateLessons) {
      [this.notes, this.notationMarks] = privateLessons;
    }
  }
}
